module.exports = __webpack_public_path__ + "img/valdisole.b2dfab0f.svg";